// Despertami — fade-out de página antes de navegar a un link interno (mejora progresiva, ver
// docs/brand.md#movimiento). El fade-IN es puro CSS (@keyframes en base.css), no necesita JS ni
// arriesga una pantalla en blanco si este script falla o tarda en cargar.
//
// Si algo sale mal (origen distinto, modificadores de teclado, link especial), simplemente no
// llamamos preventDefault y el navegador hace la navegación normal — nunca bloquea un click.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var OUT_CLASS = 'page-transitions-out';
  var OUT_DELAY_MS = 220; // ligeramente menor a --duration-base (280ms) para que se sienta ágil

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;

    var href = link.getAttribute('href') || '';
    if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (e) {
      return;
    }
    if (url.origin !== window.location.origin) return;
    if (url.pathname === window.location.pathname && url.hash) return; // ancla en la misma página

    event.preventDefault();
    document.documentElement.classList.add(OUT_CLASS);
    window.setTimeout(function () {
      window.location.href = link.href;
    }, OUT_DELAY_MS);
  });

  // Handoff al checkout de Shopify (fuera de nuestro control, no se puede re-skinear por código
  // del tema — ver docs/brand.md y el plan de rediseño). Solo agregamos la clase de salida al
  // envío real del botón "Checkout"; nunca llamamos preventDefault, así que el formulario se
  // sigue enviando con normalidad aunque el fade no alcance a completarse.
  document.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    if (!submitter || submitter.getAttribute('name') !== 'checkout') return;
    document.documentElement.classList.add(OUT_CLASS);
  });
})();
